export default {
  SET_UNITS: (state, units) => (state.units = units),
  SET_UNITS_GROUPS: (state, groups) => (state.unitsGroups = groups),
  SET_SELECTED_UNITS: (state, units) => (state.selectedUnits = units),
  SET_UNAVAILABLE_UNITS_IDS: (state, unitsIds) => (state.unavailableUnitsIds = unitsIds),
  SET_UNIT: (state, unit) => (state.unitSelected = unit),
  SET_TAG_LIST: (state, tagList) => (state.tagList = tagList),
  DELETED_TAG: (state, deletedTag) => (state.deletedTag = deletedTag),
  UPDATED_TAG: (state, updatedTag) => (state.updatedTag = updatedTag),
}
